@use '@lib/assets/styles/main.scss' as *;

.stickyTopContent {
  position: sticky;
  top: 0;
  z-index: $zIndexStickyHeader;
}

.stickyTopContentOfflineMessage {
  padding-bottom: 0 !important;
}
